// Regex pattern for email
export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

export const MULTIPLE_EMAIL_REGEX =
  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}(,[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,16}$/

// eslint-disable-next-line no-useless-escape
export const STORE_AGGEREGATOR_ID_REGEX = /^[^\/\\]*(?:[\/\\][^\/\\]*)*$/

export const NUMBER_REGEX = /^([1-9][0-9]*)$/

export const NUMERIC_ONLY_REGEX = /^[0-9]+$/

export const OOS_THRESHOLD_REGEX = /^(0|[1-9][0-9]*)$/

export const NO_SPECIAL_CHAR = /^[^!@#$%^&*()+=\\[\]{};:'",.<>?/`~]*$/

export const HOST_REGEX =
  /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/

// Accepts http(s):// URLs with any hostname (domain, localhost, or IP),
// an optional port, and an optional path/query/hash — unlike yup's built-in
// `.url()`, which rejects `http://localhost:5173`-style dev URLs.
export const URL_REGEX = /^https?:\/\/[a-zA-Z0-9.-]+(:\d+)?(\/[^\s]*)?$/
